import React from 'react';
import PropTypes from 'prop-types';
import ViewMore from '../view-more';
import * as styles from './description.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Description = props => ___EmotionJSX("div", {
  css: styles.base
}, ___EmotionJSX(ViewMore, {
  expandedHeight: props.viewHeight,
  expandedText: "Read less",
  contractedText: "Read more"
}, () => ___EmotionJSX(React.Fragment, null, props.title && ___EmotionJSX("div", {
  css: styles.columns
}, ___EmotionJSX("div", {
  css: styles.columnLeft
}, ___EmotionJSX("span", {
  css: styles.title
}, props.title), ___EmotionJSX("div", {
  css: styles.name
}, props.name)), ___EmotionJSX("div", {
  css: styles.columnRight
}, props.logo && ___EmotionJSX("img", {
  css: styles.logo,
  src: props.logo,
  alt: ""
}))), ___EmotionJSX("div", {
  css: props.fontSize === 'small' ? styles.smallFont : styles.content,
  dangerouslySetInnerHTML: {
    __html: props.description
  } // eslint-disable-line react/no-danger
}))));
Description.propTypes = {
  description: PropTypes.string.isRequired,
  viewHeight: PropTypes.number,
  title: PropTypes.string,
  name: PropTypes.string,
  logo: PropTypes.string,
  fontSize: PropTypes.string
};
Description.defaultProps = {
  viewHeight: 130,
  title: null,
  name: null,
  logo: null,
  fontSize: ''
};
export default Description;